<template>
  <span v-if="contributor">
    {{ contributor.name }}
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    id: {
      type: String
    },
  },
  created() {
    this.fetchContributor(this.id);
  },
  computed: {
    ...mapGetters({
      contributors: 'contributors/items',
    }),
    contributor() {
      return this.contributors[this.id];
    },
  },
  methods: {
    ...mapActions({
      fetchContributor: 'contributors/fetchContributor'
    }),
  }
};
</script>
